export default __webpack_public_path__ + "static/media/t.min.ab713ec9.png";